import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";


function LinkSettings(props) {
  const navigate = useNavigate();
  const [editUser, setEditUser] = useState({
    ios_app_store_id: "",
    ios_url: "",
    ipad_app_store_id: "",
    ipad_url: "",
    android_url: "",
    windows_phone_app_store_id: "",
    android_app_store_id: "",
    windows_phone_url: "",
    user_id: "",
  });
  const [message, setMessage] = useState("");
  const access_token = localStorage.getItem("access_token");
  const [errors, setErrors] = useState({});

  // console.log(access_token)

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  useEffect(async () => {
    const getUser = async () => {
      const reqData = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/deep_linking_setting/index`,
        { headers: headers }
      );

      const resData = await reqData?.json();
      var res = resData?.Deep_Linking_Setting;
      setEditUser(res);
      //    console.log(resData)
      //    console.log(res)
    };
    getUser();
  }, []);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setEditUser({ ...editUser, [name]: value });
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const isValidURL = (url) => {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' +
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
      '((\\d{1,3}\\.){3}\\d{1,3}))' +
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
      '(\\?[;&a-z\\d%_.~+=-]*)?' +
      '(\\#[-a-z\\d_]*)?$',
      'i'
    );
    return !!pattern.test(url);
  };

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  //  ios_url: "",
  //   ipad_app_store_id: "",
  //   ipad_url: "",
  //   android_url: "",
  //   windows_phone_app_store_id: "",
  //   android_app_store_id: "",
  //   windows_phone_url: "",

  const handleUpdate = async (e) => {
    e.preventDefault();

    let validationErrors = {};

    if (editUser.ios_url && !isValidURL(editUser.ios_url)) {
      validationErrors.ios_url = "Please enter a valid IOS URL.";
    }

    if (editUser.ipad_url && !isValidURL(editUser.ipad_url)) {
      validationErrors.ipad_url = "Please enter a valid IPAD URL.";
    }

    if (editUser.android_url && !isValidURL(editUser.android_url)) {
      validationErrors.android_url = "Please enter a valid Android URL.";
    }

    if (editUser.windows_phone_url && !isValidURL(editUser.windows_phone_url)) {
      validationErrors.windows_phone_url = "Please enter a valid windows phone URL.";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setProcessing(false);
      setShowOverlay(false);
      return;
    }

    const editInputvalue = {
      ios_app_store_id: editUser?.ios_app_store_id,
      ios_url: editUser?.ios_url,
      ipad_app_store_id: editUser?.ipad_app_store_id,
      ipad_url: editUser?.ipad_url,
      android_app_store_id: editUser?.android_app_store_id,
      android_url: editUser?.android_url,
      windows_phone_app_store_id: editUser?.windows_phone_app_store_id,
      windows_phone_url: editUser?.windows_phone_url,
      user_id: editUser?.user_id,
    };

    let firstApiStatus = false;
    let resultapi = null;
    let resjson = null;
    setProcessing(true);
    setShowOverlay(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/deep_linking_setting/store`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(editInputvalue),
        }
      );

      resjson = await res.json();

      if (resjson.status === true) {
        firstApiStatus = true;
        resultapi = resjson;
      }
    } catch (error) {
      console.error("Error:", error);
    }

    if (firstApiStatus) {
      props.setApiresponsealert(resultapi);
      props.setShowalert(true);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      if (resjson.status === false) {
        var resultError = resjson;
        props.setApiresponsealert(resultError);
        props.setShowalert(true);
        setProcessing(false);
        setShowOverlay(false);
      }
    }
  };

  // const handleUpdate = async (e) => {
  //   e.preventDefault();
  //   const editInputvalue = {
  //     ios_app_store_id: editUser?.ios_app_store_id,
  //     ios_url: editUser?.ios_url,
  //     ipad_app_store_id: editUser?.ipad_app_store_id,
  //     ipad_url: editUser?.ipad_url,
  //     android_app_store_id: editUser?.android_app_store_id,
  //     android_url: editUser?.android_url,
  //     windows_phone_app_store_id: editUser?.windows_phone_app_store_id,
  //     windows_phone_url: editUser?.windows_phone_url,
  //     user_id: editUser?.user_id,
  //   };
  //   // console.log(editInputvalue);
  //   let res = await fetch(
  //     `${process.env.REACT_APP_Baseurl}/admin/deep_linking_editUser/store`,
  //     {
  //       method: "POST",
  //       headers: headers,
  //       body: JSON.stringify(editInputvalue),
  //     }
  //   );

  //   let resjson = await res.json();
  //   // console.log(resjson)
  //   if (res.status === 200) {
  //     setMessage(resjson.success);
  //     alert("Success");
  //     setTimeout(() => {
  //       window.location.reload();
  //     }, 2000);
  //   } else {
  //     setMessage("Some error Occured");
  //     console.log("Error");
  //     alert("Enter Correct Details");
  //   }
  // };

  return (
    <>
      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading={"Link Settings"} saveText={"Update Settings"} saveMethod={handleUpdate} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={"Create Link"} />
            <MessageLabel text={"IOS App Store ID"} />
            <AdminCustomInput type="text" placeHolder={"Enter IOS app store ID"} id="ios_app_store_id" name="ios_app_store_id" onChange={handleInput} value={editUser?.ios_app_store_id} />
            <MessageLabel text={"IPAD App Store ID"} />
            <AdminCustomInput type="text" placeHolder={"Enter IPAD App Store ID"} id="ipad_app_store_id" name="ipad_app_store_id" onChange={handleInput} value={editUser?.ipad_app_store_id} />
            <MessageLabel text={"Android App Store ID"} />
            <AdminCustomInput type="text" placeHolder={"Enter Android App Store ID"} id="android_app_store_id" name="android_app_store_id" onChange={handleInput} value={editUser?.android_app_store_id} />
            <MessageLabel text={"Windows Phone App Store ID"} />
            <AdminCustomInput type="text" placeHolder={"Enter Windows Phone App Store ID"} id="windows_phone_app_store_id" name="windows_phone_app_store_id" onChange={handleInput} value={editUser?.windows_phone_app_store_id} />
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={"URL Settings"} />
            <MessageLabel text={"IOS URL"} />
            <AdminCustomInput type="text" placeHolder={"Enter IOS URL"} id="ios_url" name="ios_url" onChange={handleInput} value={editUser?.ios_url} error={errors.ios_url} />
            <MessageLabel text={"IPAD URL"} />
            <AdminCustomInput type="text" placeHolder={"Enter IPAD URL"} id="ipad_url" name="ipad_url" onChange={handleInput} value={editUser?.ipad_url} error={errors.ipad_url} />
            <MessageLabel text={"Android URL"} />
            <AdminCustomInput type="text" placeHolder={"Enter Android URL"} id="android_url" name="android_url" onChange={handleInput} value={editUser?.android_url} error={errors.android_url} />
            <MessageLabel text={"Windows Phone URL"} />
            <AdminCustomInput type="text" placeHolder={"Enter Windows Phone URL"} id="windows_phone_url" name="windows_phone_url" onChange={handleInput} value={editUser?.windows_phone_url} error={errors.windows_phone_url} />
          </Wrapper>
        </RightWrapper>
      </FormContainer>

      {/* <div className=" m-0 p-0">
        <div className="">
          <section className="section container-fluid ">
            <div className=" p-2">
              <div className="iq-card">
                <div className="">
                  <form
                    id="update-menu-form"
                    accept-charset="UTF-8"
                    action=""
                    method="post"
                  >
                    <div>
                      <h4>
                        <i className="entypo-globe"></i> Link Settings
                      </h4>
                      <hr />
                    </div>
                    <div className="">
                      <div className="row mt-3">
                        <div className="col-md-6">
                          <div className="home">
                            <label for="slug">IOS App Store ID</label>
                            <input
                              name="ios_app_store_id"
                              id="ios_app_store_id"
                              placeholder="IOS App Store ID"
                              className="form-control"
                              onChange={handleInput}
                              value={editUser?.ios_app_store_id}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="home">
                            <label for="slug">IOS URL</label>
                            <input
                              name="ios_url"
                              id="ios_url"
                              placeholder="IOS URL"
                              className="form-control"
                              onChange={handleInput}
                              value={editUser?.ios_url}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-6">
                          <div className="home">
                            <label for="slug">IPAD App Store ID</label>
                            <input
                              name="ipad_app_store_id"
                              onChange={handleInput}
                              value={editUser?.ipad_app_store_id}
                              id="ipad_app_store_id"
                              placeholder="IPAD App Store ID"
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="home">
                            <label for="slug">IPAD URL</label>
                            <input
                              name="ipad_url"
                              id="ipad_url"
                              placeholder="IPAD URL"
                              className="form-control"
                              onChange={handleInput}
                              value={editUser?.ipad_url}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-6">
                          <div className="home">
                            <label for="slug">Android App Store ID</label>
                            <input
                              name="android_app_store_id"
                              id="android_app_store_id"
                              onChange={handleInput}
                              value={editUser?.android_app_store_id}
                              placeholder="Android App Store ID"
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="home">
                            <label for="slug">Android URL</label>
                            <input
                              name="android_url"
                              id="android_url"
                              onChange={handleInput}
                              value={editUser?.android_url}
                              placeholder="Android URL"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-6">
                          <div className="home">
                            <label for="slug">Windows Phone App Store ID</label>
                            <input
                              name="windows_phone_app_store_id"
                              onChange={handleInput}
                              value={editUser?.windows_phone_app_store_id}
                              id="windows_phone_app_store_id"
                              placeholder="Windows Phone App Store ID"
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="home">
                            <label for="slug">Windows Phone URL</label>
                            <input
                              name="windows_phone_url"
                              id="windows_phone_url"
                              onChange={handleInput}
                              value={editUser?.windows_phone_url}
                              placeholder="Windows Phone URL"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="mt-5 text-right home d-flex justify-content-end">
                      <Link
                        type="submit"
                        className="btn btn-primary"
                        id="submit-update-menu"
                        onClick={handleUpdate}
                      >
                        Update
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div> */}
    </>
  );
}

export default LinkSettings;
